
$ = jQuery

/*
Load sibling page (and parent page) content dynamically instead of
following the link normally
*/

function checkEmpty(value) {
  return value != '';
}


function sidebar_scrolling(){
  if($(window).width() < 992 || !$('.sidebar').length ||  $('.sidebar-components').height() > window.innerHeight ) {
    return;
  }

  isIntersecting();


  var start = $('.sidebar').offset().top,
  //wScroll = $(window).scrollTop() + $('.main-nav').height() + ($(window).innerHeight() / 20),

      wScroll = $(window).scrollTop() + $('.top-nav').outerHeight();

  //theTop = $('.main-nav').height() + ($(window).innerHeight() / 20);

  theTop = $('.top-nav').height() + $(window).innerHeight() / 15;


  if(wScroll > start){
    $('.sidebar-components').css({
      position: 'fixed',
      top: theTop+'px'
    });
  } else {
    $('.sidebar-components').css({
      position: '',
      top: 0
    });
  }
}


$(window).on('load scroll resize', function(){
  sidebar_scrolling();
});
